<template>
  <div class="lo-dashboard">
    <h2 class="text__center">Loan Officers</h2>
    <Filters :filters="filters"></Filters>
    <p class="flex__between flex__wrap">
      <span class="mr-10">Showing {{ shownLenders }} out of {{ countLenders }} lenders</span>
      <ExportData :data="filteredLenders" />
    </p>
    <div class="tile-group">
      <LenderTile v-for="lender in lenders" :key="lender._id" :lender="lender" />
    </div>
    <scroll-loader v-if="count < countLenders" :loader-method="showMore" :loader-color="'#4a773c'"></scroll-loader>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Filters from "./Filters";
import ExportData from "./Export-Data";
import LenderTile from "./LenderTile";
export default {
  components: {
    Filters,
    ExportData,
    LenderTile
  },
  data() {
    return {
      count: 18
    };
  },
  computed: {
    ...mapGetters({
      filters: "loanOfficers/getFilters",
      filteredLenders: "loanOfficers/getFilteredLoanOfficers"
    }),
    lenders() {
      return this.filteredLenders.slice(0, this.shownLenders);
    },
    countLenders() {
      return this.filteredLenders.length;
    },
    shownLenders() {
      if (this.count > this.countLenders) {
        return this.countLenders;
      } else {
        return this.count;
      }
    }
  },
  methods: {
    showMore() {
      // artificially delay loading more requests by half a second
      setTimeout(() => {
        if (this.count + 12 > this.countLenders) {
          this.count = this.countLenders;
        } else {
          this.count += 12;
        }
      }, 500);
    }
  }
};
</script>

<style scoped lang="scss">
</style>